import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import BookletInCompanyColumn from './BookletInCompanyColumn';
import { FiEdit } from 'react-icons/fi';
import { IoDuplicateOutline } from 'react-icons/io5';
import BesparingIcon from '../../../../img/besparing.svg';
import { FaSpinner } from 'react-icons/fa';
import { MdDragIndicator } from 'react-icons/md';

export function SortableRow({
  coupon,
  index,
  coupons,
  isEditingPosition,
  company,
  handleConfirmEdit,
  handleDuplicate,
  handleEditCoupon,
  filteredBooklets,
  selectedCouponIds,
  setSelectedCouponIds,
  contactEmails,
  zoneId,
  isCompanyInView,
  companyHeight,
  companyIndex,
  fetchCoupons,
  getDateClassName,
  isDateActive,
  setIsHovered,
  handleOpenBulkEditor,
  isUpdating,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id: coupon._id,
    disabled: !isEditingPosition || isUpdating,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className="coupon"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <td></td>

      <td
        colSpan={4}
        className={`coupon-title ${index % 2 === 0 ? 'gray' : ''}`}
        onClick={() => handleConfirmEdit(coupon)}
      >
        <span>
          <div className="flex items-center">
            <button
              {...attributes}
              {...listeners}
              className="drag-handle"
              onClick={(e) => e.stopPropagation()}
            >
              {isUpdating ? <FaSpinner /> : <MdDragIndicator />}
            </button>
            <small style={{ opacity: 0.8, marginRight: '.5rem' }}>#{coupon.position ?? -1}</small> {coupon.discount + ' ' + coupon.smallTitle}
          </div>

          <span>
            {coupon.estimatedSavings && (
              <div className="flex items-center gap-1 amount">
                <img src={BesparingIcon} alt="Besparing" />
                <small>{coupon.estimatedSavings} kr</small>
              </div>
            )}

            <button onClick={(e) => handleDuplicate(e, coupon)}>
              <IoDuplicateOutline size={20} />
            </button>

            <button onClick={(e) => handleEditCoupon(e, coupon)}>
              <FiEdit size={20} />
            </button>

            <p className="coupon-totalAmount">
              {coupon.usedCouponsResult.totalAmount}
            </p>
          </span>
        </span>
      </td>

      {index === 0 &&
        filteredBooklets?.map((bookletItem, i) => (
          <BookletInCompanyColumn
            key={bookletItem._id}
            coupons={coupons}
            selectedCouponIds={selectedCouponIds[bookletItem._id] || []}
            setSelectedCouponIds={setSelectedCouponIds}
            booklet={bookletItem}
            contactEmails={contactEmails}
            zoneId={zoneId}
            company={company}
            isCompanyInView={isCompanyInView}
            companyHeight={companyHeight}
            companyIndex={companyIndex}
            bookletIndex={i}
            refetchCoupons={fetchCoupons}
            onOpenBulkEditor={handleOpenBulkEditor}
          />
        ))}
    </tr>
  );
}
